import { Box, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { HeaderFilterBox, CustomTextField } from '../../../common/components';

const SubcontractorsFilters = ({ searchTerm, onSearchChange }) => {
  const baseInputStyles = {
    width: { xs: '100%', sm: '48%', md: '22%' },
    mt: 0,
  };

  return (
    <HeaderFilterBox variant="oneRow">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          alignItems: 'center',
          width: '100%',
        }}
      >
        <CustomTextField
          label="Descripción"
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          size="medium"
          sx={{ ...baseInputStyles, width: { xs: '100%', sm: '48%', md: '28%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'primary.main' }} />
              </InputAdornment>
            ),
          }}
        />

      </Box>
    </HeaderFilterBox>
  );
};

export default SubcontractorsFilters;
